import typeCheck from 'common/util/typeCheck';

import { SR_API_ACTION_UTILITY_PAYOUTS_GET_PENDING_PAYOUTS_BY_PARTNER_SLUG } from 'api/utilityActionTypes';

export default async function getPendingPayoutsByPartnerSlug(
  { state, utilityApiClient },
  { slug, forceRefresh = false },
) {
  typeCheck('slug::NonEmptyString', slug);

  const currentStatePath = ['utilityPayouts', 'pendingPayouts', 'byPartnerSlug', slug];

  if (state.get(currentStatePath) && !forceRefresh) {
    return state.get(currentStatePath);
  }

  return utilityApiClient.postWithState({
    action: SR_API_ACTION_UTILITY_PAYOUTS_GET_PENDING_PAYOUTS_BY_PARTNER_SLUG,
    state: state,
    payload: {
      slug,
    },
    onSuccess(partnerEarnings) {
      if (partnerEarnings) {
        state.set(currentStatePath, partnerEarnings);
      }
    },
  });
}
